import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaHeart, FaRegHeart, FaShareAlt, FaArrowLeft } from "react-icons/fa";
import BottomNav from "../BottomNav";
import "./ViewIdeaPage.css";
import { supabase } from "./supabaseClient"; // ✅ Make sure this path is correct
import { color } from "framer-motion";
import { notificationService } from '../utils/notificationService';

const ONE_HOUR = 60 * 60;

const ViewLeaderboardIdeaPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const idea = state?.idea;

  const [liked, setLiked] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      if (idea?.imagePath) {
        const { data, error } = await supabase
          .storage
          .from("images") // ✅ your actual bucket name
          .createSignedUrl(idea.imagePath, ONE_HOUR);

        if (error) {
          console.error("Error fetching signed URL:", error.message);
        } else {
          setImageUrl(data.signedUrl);
        }
      }
    };

    fetchImage();
  }, [idea]);

  const toggleLike = () => setLiked(prev => !prev);

  const handleShare = async () => {
    await navigator.clipboard.writeText(window.location.href);
    notificationService.showSuccess("Link copied to clipboard!");
  };

  if (!idea) {
    return <div className="loading">No idea data provided</div>;
  }

  return (
    <div className="view-idea-container">
      <div className="view-box">
        {/* Top Header */}
        <div className="header-row">
          <FaArrowLeft
            className="back-icon"
            style={{ marginRight: "1rem", cursor: "pointer" }}
            onClick={() => navigate(-1)}
          />
          <div className="avatar-circle">
            {idea.authorName?.[0]?.toUpperCase() || "U"}
          </div>
          <p className="author-name">{idea.authorName || "Unknown"}</p>
        </div>

        {/* Image area */}
        {imageUrl ? (
          <div className="image-wrapper">
            <img src={imageUrl} alt="Idea" className="view-idea-image" />
          </div>
        ) : (
          <div className="image-placeholder">Loading image...</div>
        )}

        {/* Post time */}
        <p className="posted-time">Posted recently</p>

        {/* Tags */}
        <div className="tag-container">
          {idea.tags?.length > 0 ? (
            idea.tags.map((tag, idx) => (
              <span key={idx} className="tag">
                {tag}
              </span>
            ))
          ) : (
            <span className="tag">
              No tags
            </span>
          )}
        </div>

        {/* Description */}
        <p className="description-text" style={{ color: "#e0e0e0" }}>{idea.description || "No description provided."}</p>

        {/* Action Buttons */}
        <div className="action-buttons">
          <span onClick={toggleLike}>
            {liked ? <FaHeart className="heart liked" /> : <FaRegHeart className="heart" />}
          </span>
          <FaShareAlt className="share" onClick={handleShare} />
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default ViewLeaderboardIdeaPage;
